import { RootState } from '../../store';

export const getUserNotificationConfig = (state: RootState): any => {
  return state?.userConfigs?.configs.find?.(
    (config) => config.type === 'UserNotificationsConfig',
  );
};
